var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomingCallDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 87,
    viewBox: "0 0 92 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 24.5C2.79999 10.1 10.8333 5.16669 15 4.50002L16.5 4.00002C22.9 2.00002 27.1667 4.83336 28.5 6.50002L32 13.5C36.4 21.5 31.5 27.5 28.5 29.5C22.1 33.5 23.1667 38.5 24.5 40.5L29 49.5C34.6 57.5 38.3333 57.5 39.5 56.5L44.5 55C50.9 52.2 55.1667 55.5 56.5 57.5L62.5 65.5C66.5 70.7 62.5 76 60 78C51.5 87 44 83.5 42 82.5C40.4 81.7 35.3333 78.5 33 77C25 70 19.5 62.5 13 52C7.8 43.6 4.83332 30.1667 3.99999 24.5Z",
    stroke: "#517DDA",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.947 37.6617L55.8425 34.3338L54.2762 34.1342C53.5801 34.0454 52.2764 33.1735 52.6305 30.396C52.9846 27.6185 55.0122 11.7139 55.9817 4.10878",
    stroke: "#517DDA",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7796 9.65084C91.3083 8.46788 91.5886 6.2696 90.4057 4.74085C89.2227 3.2121 87.0244 2.93178 85.4957 4.11474L89.7796 9.65084ZM56.7802 35.186L89.7796 9.65084L85.4957 4.11474L52.4964 29.6499L56.7802 35.186Z",
    fill: "#517DDA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCallDashboard);
export default __webpack_public_path__ + "static/media/incoming_call_dashboard.a40cbb7ad8f8775a9e016e2774dc1325.svg";
export { ForwardRef as ReactComponent };